import type { Backend } from '@freelancer/datastore/core';
import {
  OrderByDirection,
  getQueryParamValue,
} from '@freelancer/datastore/core';
import { toNumber } from '@freelancer/utils';
import type { SuperuserGroupMembersCollection } from './superuser-group-members.types';

export function superuserGroupMembersBackend(): Backend<SuperuserGroupMembersCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (_authUid, ids, query, _order) => {
      const [groupId] = getQueryParamValue(query, 'groupId');
      if (!groupId) {
        throw new Error('Group ID must be provided');
      }

      return {
        endpoint: `superuser/0.1/groups/${groupId}/members`,
        params: {
          members: ids?.map(toNumber),
          users: getQueryParamValue(query, 'userId'),
          roles: getQueryParamValue(query, 'role'),
          user_search: query?.searchQueryParams.userSearch,
          offset: query?.searchQueryParams.offset,
          include_count: true,
        },
      };
    },
    push: (_authUid, groupMember) => {
      return {
        endpoint: `superuser/0.1/groups/${groupMember.groupId}/members/`,
        method: 'POST',
        payload: {
          role: groupMember.role,
          user_id: groupMember.userId,
          group_id: groupMember.groupId,
        },
      };
    },
    update: (_authUid, { role }, { groupId, id }) => {
      return {
        endpoint: `superuser/0.1/groups/${groupId}/members/${id}`,
        method: 'PUT',
        payload: {
          member_id: id,
          group_id: groupId,
          role,
        },
      };
    },
    remove: (_authUid, id, groupMember) => {
      return {
        endpoint: `superuser/0.1/groups/${groupMember.groupId}/members/${id}/remove`,
        method: 'POST',
        payload: {},
      };
    },
    set: undefined,
  };
}
